export default __webpack_public_path__ + "static/media/bb2.65a7a74d.png";